import React from "react";
import PropTypes from "prop-types";
import { FixedHeader, PrimaryHeader, SecondaryHeader } from "../../ui/Header";
import AggregatorTable from "./AggregatorTable.js";
import ButtonGroup from "../../ui/ButtonGroup/ButtonGroup";
import Button from "../../ui/Button/Button";
import * as urls from "../../utils/urls";
import Select from "../../ui/Select/Select";
import "./TeaserAggregator.scss";
import ReloadIcon from "./reload.svg";
import CampaignsSelect from "../../components/CampaignsSelect";
import Loader from "../../ui/Loader/Loader";
import InfiniteScroll from "../../components/InfiniteScroll";

const TeaserAggregator = ({
  onNextClick,
  items,
  selectedItems,
  campaign,
  onCampaignSelect,
  period,
  onPeriodChange,
  onCheckChange,
  hasMore,
  onNextLoad,
  refreshLoading,
  onRefreshClick,
  scroll,
  setScroll
}) => {
  const isNextEnabled = selectedItems.length != 0;

  React.useEffect(() => {
    window.scrollTo(0, scroll);

    return () => {
      setScroll(window.scrollY);
    };
  }, []);

  return (
    <div className="teaser-aggregator">
      <FixedHeader className="teaser-aggregator__header">
        <PrimaryHeader>
          <span className="header__title">Создание анонса</span>
          <ButtonGroup
            items={[
              { title: "Вручную", code: urls.teaserAdd(), exact: true },
              { title: "Агрегатор", code: urls.teaserAddAggregator() }
            ]}
            theme={"dark"}
            selected="add"
            nav
          />
          <Button
            className="teaser-aggregator__create-btn"
            color="green"
            onClick={onNextClick}
            disabled={!isNextEnabled}
          >
            Продолжить
          </Button>
        </PrimaryHeader>
        <SecondaryHeader>
          <div className="teaser-aggregator__controls">
            <CampaignsSelect
              placeholder="Кампания"
              className="campaign"
              value={campaign}
              onSelect={onCampaignSelect}
              searchParams={{ has_scraper: true }}
            />
            <ButtonGroup
              items={[
                { title: "Сегодня", code: 1 },
                { title: "1 неделя", code: 7 },
                { title: "2 недели", code: 14 },
                { title: "30 дней", code: 30 }
              ]}
              selected={period}
              onClick={onPeriodChange}
              className="teaser-aggregator__period-group"
            />
            <Button
              icon={ReloadIcon}
              color="light-blue"
              className="teaser-aggregator__reload-btn"
              disabled={refreshLoading}
              onClick={onRefreshClick}
            />
            <span className="teaser-aggregator__info">
              Загружено новостей: {items.length}
            </span>
            <span className="teaser-aggregator__info">
              Выбрано новостей: {selectedItems.length}
            </span>
          </div>
        </SecondaryHeader>
      </FixedHeader>

      <div className="content-body content-body__with-fixed-secondary">
        <InfiniteScroll onNextLoad={onNextLoad}>
          <AggregatorTable
            selected={selectedItems}
            items={items}
            onCheckChange={onCheckChange}
          />
          {hasMore && <Loader />}
        </InfiniteScroll>
      </div>
    </div>
  );
};

TeaserAggregator.propTypes = {
  items: PropTypes.array.isRequired,
  selectedItems: PropTypes.array.isRequired
};

export default TeaserAggregator;
